export default {
  DnD_ITEM_TYPE_1: 'Dictionary-Tree',
  DnD_ITEM_TYPE_2: 'Dictionary-Target',
  DnD_ITEM_TYPE_3: 'Sample-Grids',
  DnD_ITEM_TYPE_4: 'Definition-Target',
  DnD_ITEM_TYPE_5: 'ToolPalette-Item',
  DnD_ITEM_TYPE_6: 'ReportsTable-Item',
  DnD_ITEM_TYPE_7: 'Geography-Item',
};
